import { useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { api } from 'api';

export function useSignOutOn401() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const interceptor = api.global.addResponseErrorInterceptor(async (error) => {
      if (api.global.isRequestError(error)) {
        if (error.response?.status === 401) {
          await queryClient.resetQueries();
          api.global.removeDebugToken();
          return;
        }
      }
      return Promise.reject(error);
    });

    return () => {
      api.global.removeResponseInterceptor(interceptor);
    };
  }, [queryClient]);
}
